import { useRef, useState } from 'react'
import { EffectCards, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import type { Swiper as SwiperType } from 'swiper/types'
import 'swiper/css'
import 'swiper/css/effect-cards'

import { Container } from 'components/container'
import { questions } from './questions'
import { Card } from './card'
import {
  Cards,
  NavButton,
  NavigationContainer,
  SlideCount,
  StyledSection,
} from './styled'

export const Quiz = () => {
  const [index, setIndex] = useState(0)
  const [answers, setAnswers] = useState<{ [k: number]: string }>({})
  const swiperRef = useRef<SwiperType>()
  const prevButton = useRef<HTMLButtonElement>(null)
  const nextButton = useRef<HTMLButtonElement>(null)

  return (
    <StyledSection aria-label="Тест">
      <Container $mode="text">
        <Cards>
          <Swiper
            effect="cards"
            grabCursor={false}
            allowTouchMove={false}
            preventClicks={false}
            modules={[EffectCards, Navigation]}
            onTransitionStart={(swiper) => setIndex(swiper.realIndex)}
            cardsEffect={{ perSlideRotate: 3, perSlideOffset: 6 }}
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper
            }}
          >
            {questions.map((question, index) => (
              <SwiperSlide className="swiper-no-swiping" key={index}>
                <Card
                  question={question}
                  index={index}
                  selectedValue={answers[index]}
                  onAnswer={(value) =>
                    setAnswers((s) => ({ ...s, [index]: value }))
                  }
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <SlideCount>
            {index + 1} из {questions.length}
          </SlideCount>

          <NavigationContainer>
            <NavButton
              ref={prevButton}
              onClick={() => swiperRef.current?.slidePrev()}
              disabled={index < 1}
              $dir="prev"
            />
            <NavButton
              ref={nextButton}
              onClick={() => swiperRef.current?.slideNext()}
              disabled={index >= questions.length - 1 || !answers[index]}
              $dir="next"
            />
          </NavigationContainer>
        </Cards>
      </Container>
    </StyledSection>
  )
}
